// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1uoj0","header":"PatientQuestionnaire_header__2g8Px","info":"PatientQuestionnaire_info__pMHZ0"};